import {DEFAULT_PAGE} from "../../contstants";
import getDateRange from "../../utils/getDateRange";
import {GetSellOrders} from "../sell-orders/getSellOrders";

const FilterBatchOrders = async (perPage, filters) => {

    const page = filters.page || DEFAULT_PAGE;
    const type = 'batch';
    const searchInFields = filters.search_in_fields || '';
    const searchPhrase = filters.s;
    const user = searchInFields.includes('user') ? searchPhrase : '';
    const id = searchInFields.includes('id') ? searchPhrase : '';
    const office_id = filters.office_id;
    const payment_type = filters.payment_type ?? "";
    const corporate_customer_id = filters.corporate_customer_id ?? "";

    const { dateFrom, dateTo } = getDateRange(filters.date);

    return await GetSellOrders({
        limit: perPage,
        offset: (page - 1) * perPage,
        type,
        office_id,
        dateFrom,
        dateTo,
        id,
        user,
        payment_type,
        corporate_customer_id
    });
};

export default FilterBatchOrders;
